export default (options) => {
    let unirest = `
const unirest = require("unirest");

const req = unirest();

req.headers();

req.type("json");
req.send();

req.end(function (res) {
  if (res.error) throw new Error(res.error);

  console.log(res.body);
});
`

    unirest = unirest.replace(/const req = unirest\(\)/s, `const req = unirest(${JSON.stringify(options.method)}, ${JSON.stringify(options.url)})`)
    unirest = unirest.replace(/req.headers\(\)/s, `req.headers(${JSON.stringify(options.headers, false, 4)})`)
    unirest = unirest.replace(/req.send\(\)/s, `req.send(${JSON.stringify(options.data, false, 4)})`)
    return unirest
}
